export default __webpack_public_path__ + "static/media/mb-popup-close.438688c7.svg";